import { sample } from 'effector';
import {
    hideModal,
    remove,
    setIsOpened,
    setModalState,
    setPreventClosing,
    setShouldMount,
    showModal,
} from 'models/modals';
import { $modals } from 'models/store-modals';

sample({
    source: $modals,
    clock: setShouldMount,
    fn: (modals, { modalName, shouldMount }) => {
        return { ...modals, [modalName]: { ...modals[modalName], shouldMount, openTimestamp: +new Date() } };
    },
    target: $modals,
});

sample({
    source: $modals,
    clock: setModalState,
    fn: (modals, { modalName, state }) => {
        return { ...modals, [modalName]: { ...modals[modalName], state } };
    },
    target: $modals,
});

sample({
    source: $modals,
    clock: setIsOpened,
    fn: (modals, { modalName, isOpened }) => {
        return { ...modals, [modalName]: { ...modals[modalName], isOpened } };
    },
    target: $modals,
});

sample({
    source: $modals,
    clock: remove,
    fn: (modals, modalName) => {
        return { ...modals, [modalName]: undefined };
    },
    target: $modals,
});

sample({
    source: $modals,
    clock: setPreventClosing,
    fn: (modals, { modalName, preventClosing }) => {
        return { ...modals, [modalName]: { ...modals[modalName], preventClosing } };
    },
    target: $modals,
});

sample({
    source: $modals,
    clock: hideModal,
    fn: (modals, modalName) => {
        const preventClosing = modals?.[modalName]?.preventClosing;
        if (!preventClosing) {
            return { ...modals, [modalName]: { ...modals[modalName], isOpened: false } };
        }
        return modals;
    },
    target: $modals,
});

sample({
    clock: showModal,
    fn: ({ modalName }) => ({ modalName, shouldMount: true }),
    target: setShouldMount,
});

sample({
    clock: showModal,
    target: setModalState,
});

sample({
    clock: setShouldMount,
    fn: ({ modalName }) => ({ modalName, isOpened: true }),
    target: setIsOpened,
});
